import {PUPMED_SEARCH} from '../types'
  
  const INITIAL_STATE = {
    allSearchResult:[], pmids:[]
  }
  
  const pupMedReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
      case PUPMED_SEARCH:
        return {
          ...state,
          allSearchResult: payload.articles,
          pmids:payload.pmids,
        }
      default:
        return state
    }
  }
  
  export default pupMedReducer
  